const baseClass = "js-menu",
  cssClasses = {
    OPEN: "open",
    CLOSE: "close",
  },
  eventNames = {
    CLICK: "click",
    TRANSITION_END: "animationend",
  },
  selectors = {
    BASE: `.${baseClass}`,
    BUTTON: `.${baseClass}-button`,
    ITEM: `.${baseClass}-item`,
    ITEMSPANEL: `.${baseClass}-items`,
  };

/**
 * @this Menu
 * @param {HTMLElement} baseElement
 */
function bindEvents(baseElement) {
  const button = baseElement.querySelector(selectors.BUTTON),
    items = baseElement.querySelectorAll(selectors.ITEM),
    itemArr = [...items];

  button.addEventListener(eventNames.CLICK, onMenuButtonClicked.bind(this));
  itemArr.forEach((item) =>
    item.addEventListener(eventNames.CLICK, onMenuItemClicked.bind(this)),
  );
}

/**
 *
 * @this Menu
 * @param {*} event
 */
function onMenuButtonClicked(event) {
  toggleMenu.call(this);
}

/**
 *
 * @this Menu
 * @param {*} event
 */
function onMenuItemClicked(event) {
  event.preventDefault();

  closeMenu(this.baseElement);

  const href = event.target.closest("a").getAttribute("href");
  const target = document.querySelector(href);

  if (!target) return;

  setTimeout(() => {
    document.body.scrollTo({
      top: target.offsetTop - 100,
      behavior: "smooth",
    });
  }, 300);
}

/**
 * @this Menu
 */
function toggleMenu() {
  if (this.animationIsPlaying) {
    return;
  }
  this.animationIsPlaying = true;
  setTimeout(() => (this.animationIsPlaying = false), 300);

  const menu = this.baseElement,
    isOpen = menu.classList.contains(cssClasses.OPEN);

  isOpen ? closeMenu(menu) : openMenu(menu);
}

/**
 *
 * @param {HTMLElement} menu
 */
function openMenu(menu) {
  menu.classList.add(cssClasses.OPEN);
  menu.classList.remove(cssClasses.CLOSE);
}

/**
 *
 * @param {HTMLElement} menu
 */
function closeMenu(menu) {
  menu.classList.remove(cssClasses.OPEN);
  menu.classList.add(cssClasses.CLOSE);
}

class Menu {
  /**
   * Creates an instance of Menu.
   *
   * @param {HTMLElement} [baseElement=document.querySelector(selectors.BASE)]
   * @memberof Menu
   */
  constructor(baseElement = document.querySelector(selectors.BASE)) {
    if (baseElement === null) {
      return;
    }

    this.baseElement = baseElement;
    this.hash = location.hash;

    bindEvents.call(this, baseElement);
  }

  /**
   *
   * @type {HTMLElement}
   * @memberof Menu
   */
  get baseElement() {
    return this._baseElement;
  }
  set baseElement(value) {
    this._baseElement = value;
  }

  /**
   *
   * @type {boolean}
   * @memberof Menu
   */
  get animationIsPlaying() {
    return this._animationIsPlaying;
  }
  set animationIsPlaying(value) {
    this._animationIsPlaying = value;
  }

  /**
   *
   * @type {string}
   * @memberof Menu
   */
  get hash() {
    return this._hash;
  }
  set hash(value) {
    if (this._hash === value) {
      // reset location to enforece re-navigation
      location.hash = "";
    }
    this._hash = value;
  }
}

function init() {
  new Menu();
}

init();

export default Menu;
